import PageHero from "@/components/feature/PageHero";
import ContactForm from "@/pages/contact/components/ContactForm";
import { contactInfo, socialLinks } from "@/mocks/site";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

const infoItems = [
  { icon: "ri-map-pin-2-line", label: "公司地址", value: contactInfo.address },
  { icon: "ri-phone-line", label: "联系电话", value: contactInfo.phone },
  { icon: "ri-mail-line", label: "邮箱", value: contactInfo.email },
  { icon: "ri-time-line", label: "工作时间", value: contactInfo.hours },
];

export default function Contact() {
  useDocumentTitle(
    "联系我们 - 芒果传媒",
    "联系芒果传媒，获取影视制作、节目策划与内容发行的合作咨询。地址、电话、邮箱与在线留言表单。"
  );

  return (
    <div>
      <PageHero
        title="联系我们"
        subtitle="期待与影视行业客户、合作伙伴及每一位内容爱好者交流，芒果传媒随时欢迎你的咨询。"
        image="https://readdy.ai/api/search-image?query=Warm%20modern%20office%20lounge%20with%20large%20windows%20and%20city%20view%2C%20inviting%20professional%20atmosphere%2C%20amber%20tones%2C%20no%20text&width=1920&height=700&seq=mango-contact-hero&orientation=landscape"
        crumbs={[{ label: "联系我们" }]}
      />

      <section className="bg-background-50 py-14 md:py-20">
        <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Get In Touch
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 mt-3">
              让我们聊聊你的项目
            </h2>
            <p className="text-foreground-600 mt-3 text-sm md:text-base leading-relaxed">
              无论是合作咨询、项目邀约还是媒体联系，都可以通过以下方式找到我们。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              {infoItems.map((item) => (
                <div
                  key={item.label}
                  className="bg-secondary-50 rounded-lg p-5 border border-background-200/80"
                >
                  <span className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-xl text-primary-700`}></i>
                  </span>
                  <span className="block text-xs text-foreground-500 mt-4">{item.label}</span>
                  <p className="font-medium text-foreground-900 mt-1 text-sm leading-relaxed break-words">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <span className="text-sm font-medium text-foreground-800">关注我们</span>
              <div className="flex items-center gap-2.5 mt-3">
                {socialLinks.map((s) => (
                  <a
                    key={s.name}
                    href={s.href}
                    aria-label={s.name}
                    className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-800 hover:bg-primary-500 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    <i className={`${s.icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-8 rounded-lg overflow-hidden border border-background-200/80">
              <iframe
                title="芒果传媒公司位置地图"
                src={contactInfo.mapEmbed}
                width="100%"
                height="260"
                loading="lazy"
                className="block w-full"
              ></iframe>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}